import { ImageHelper, type IMediaModel } from "@nf/common";
import AppImage from "components/AppImage";

import styles from "./MediaCoverImage.module.scss";

interface MediaCoverImageProps {
  media: IMediaModel;
}

const MediaCoverImage = ({ media }: MediaCoverImageProps) => {
  const coverImage = ImageHelper.getPosterImageUrl(media.Images);

  return (
    <div className={styles.cover}>
      <AppImage src={coverImage || ""} alt={media?.Title || ""} fill={true} />
    </div>
  );
};

export default MediaCoverImage;
